import { useEffect, useState } from 'react';
import {
  BrowserRouter,
  NavLink,
  Route,
  Routes,
  useLocation,
  useMatch,
} from 'react-router-dom';
import './App.css';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import HomePage from './pages/Home';
import ProjectsPage from './pages/Projects';
import ResumePage from './pages/Resume';
import BlogPage from './pages/Blog';
import LinksPage from './pages/Links';
import ChatPage from './pages/Chat';
import DashboardPage from './pages/Dashboard';
import VegetablesPage from './pages/Vegetables';
import FruitsPage from './pages/Fruits';
import PaperToBlogPage from './pages/PaperToBlog';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#667eea',
    },
    secondary: {
      main: '#667eea',
    },
    background: {
      default: '#0f0f23',
      paper: 'rgba(255, 255, 255, 0.05)',
    },
    text: {
      primary: '#ffffff',
      secondary: '#a0a0b8',
    },
  },
  typography: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});

const tabs = [
  { id: 'home', label: 'Home', path: '/' },
  // { id: 'projects', label: 'Projects', path: '/projects' },
  // { id: 'resume', label: 'Resume', path: '/resume' },
  { id: 'blog', label: 'Blog', path: '/blog' },
  { id: 'links', label: 'Links', path: '/links' },
  { id: 'chat', label: 'Virtual me', path: '/chat' },
];

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      try {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch {
        window.scrollTo(0, 0);
      }
    }
  }, [pathname]);
  return null;
}

function NavTab({ tab }) {
  const match = useMatch({ path: tab.path, end: tab.path === '/' });
  return (
    <Button
      color="inherit"
      component={NavLink}
      to={tab.path}
      end={tab.path === '/'}
      className={match ? 'tab active' : 'tab'}
    >
      {tab.label}
    </Button>
  );
}

function AppShell({ messages, setMessages }) {
  return (
    <>
      <ScrollToTop />
      <AppBar position="static" className="appBar">
        <Toolbar className="toolbar">
          <div className="tabs">
            {tabs.map((tab) => (
              <NavTab key={tab.id} tab={tab} />
            ))}
          </div>
        </Toolbar>
      </AppBar>

      <Container className="main" maxWidth="lg">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/resume" element={<ResumePage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/links" element={<LinksPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/vegetables" element={<VegetablesPage />} />
          <Route path="/fruits" element={<FruitsPage />} />
          <Route path="/paper-to-blog" element={<PaperToBlogPage />} />
          <Route
            path="/chat"
            element={
              <ChatPage messages={messages} setMessages={setMessages} />
            }
          />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </Container>
    </>
  );
}

export default function Portfolio() {
  const [messages, setMessages] = useState([]);

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <BrowserRouter>
        <AppShell messages={messages} setMessages={setMessages} />
      </BrowserRouter>
    </ThemeProvider>
  );
}
